import { render, staticRenderFns } from "./SelectMonedaJson.vue?vue&type=template&id=3a6272d8&"
import script from "./SelectMonedaJson.vue?vue&type=script&lang=js&"
export * from "./SelectMonedaJson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
